import axios from 'axios';

const baseEndpoint = 'v1/chat-configurations';

const ChatConfigurationService = {

  getChatConfig() {
    return axios
      .get( baseEndpoint )
  },

  updateChatConfig( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default ChatConfigurationService;



// WEBPACK FOOTER //
// ./services/ChatConfigurationService.js